/**
 * Returns true when an item was published in the last 24 hours.
 * Accepts either a full ISO datetime (`2026-06-22T08:25:55+00:00`)
 * or a date-only string (`2026-06-22`, treated as 00:00 UTC).
 */
export const isFresh = (publishedAt, createdAt) => {
  const raw = (publishedAt || createdAt || "").trim();
  if (!raw) return false;
  const iso = raw.length === 10 ? `${raw}T00:00:00Z` : raw;
  const ts = Date.parse(iso);
  if (Number.isNaN(ts)) return false;
  return Date.now() - ts < 24 * 60 * 60 * 1000;
};

const FreshBadge = ({ publishedAt, createdAt, lang = "en" }) => {
  if (!isFresh(publishedAt, createdAt)) return null;
  return (
    <span
      data-testid="fresh-badge"
      className="inline-flex items-center gap-1 px-1.5 py-0.5 text-[9px] font-mono-dl uppercase tracking-[0.18em] bg-[#FFD400] text-[#111827] border border-[#111827]"
    >
      <span className="w-1 h-1 rounded-full bg-[#111827] animate-pulse" />
      {lang === "fr" ? "Nouveau" : "New"}
    </span>
  );
};

export default FreshBadge;
